import classNames from 'classnames';

import styles from '../../../styles/icons/base.module.scss';

interface CircleLockProps {
    color?: string;
    iconColor?: string;
    className?: string;
}

function CircleLock({
    color = 'currentColor',
    iconColor = '#000',
    className = null,
}: CircleLockProps) {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={classNames([styles.container, { [className]: className !== null }])}
        >
            <rect width="24" height="24" rx="12" fill={color} />
            <path
                d="M8.66667 11.3333V8.66666C8.66667 7.78261 9.01786 6.93476 9.64298 6.30964C10.2681 5.68452 11.1159 5.33333 12 5.33333C12.8841 5.33333 13.7319 5.68452 14.357 6.30964C14.9821 6.93476 15.3333 7.78261 15.3333 8.66666V11.3333M7.33333 11.3333H16.6667C17.403 11.3333 18 11.9303 18 12.6667V17.3333C18 18.0697 17.403 18.6667 16.6667 18.6667H7.33333C6.59695 18.6667 6 18.0697 6 17.3333V12.6667C6 11.9303 6.59695 11.3333 7.33333 11.3333Z"
                stroke={iconColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default CircleLock;
